module.exports = __webpack_public_path__ + "img/1531380900.80b9a109.jpg";